import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ZXingScannerModule } from '@zxing/ngx-scanner';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { ScannerComponent } from './scanner/scanner.component';
import { FamilyComponent } from './family/family.component';
import { GradoComponent } from './grado/grado.component';

import { APP_ROUTING } from './app.routes';

import {AuthGuard} from './services/auth-guard.service';
import {AuthService} from './services/auth.service';
import {FamilyService} from './services/family.service';
import {GradoService} from './services/grado.service';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { environment } from '../environments/environment';
import { AngularFireModule } from 'angularfire2';
import {AngularFireDatabase, AngularFireDatabaseModule} from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';

import {HttpClientModule, HttpClient} from '@angular/common/http';



import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import {ModalModule, TypeaheadModule} from 'ngx-bootstrap';
import { ListPipe } from './pipes/list.pipe';
import { AllComponent } from './all/all.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    HomeComponent,
    ScannerComponent,
    FamilyComponent,
    GradoComponent,
    ListPipe,
    AllComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    ZXingScannerModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    TypeaheadModule.forRoot(),
    HttpClientModule,
    APP_ROUTING
  ],
  providers: [AuthGuard, AuthService, FamilyService, GradoService, AngularFireDatabase],
  bootstrap: [AppComponent]
})
export class AppModule { }
